import { getSubmitUrl } from './config'

export async function createConcierge(
  url: string,
  email: string,
  product: string,
): Promise<Response> {
  try {
    const response = await fetch(getSubmitUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        url,
        email,
        product,
      }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}
